import { Button, Card, Col, DatePicker, Form, Input, Row, Select, Table ,Typography} from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { SortOrder } from 'antd/lib/table/interface';
import { Excel } from 'antd-table-saveas-excel';
import form from 'antd/lib/form';
import { useForm } from 'antd/lib/form/Form';
import { UnitcodeService } from '../../../../../../shared-services/masters/src/lib/unit-code.services'
import { DutyDrawBackReportReq } from '@gtpl/shared-models/finance';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { PlantsDropDown } from '@gtpl/shared-models/masters';
import moment from 'moment';
const ExportReceivablesAgingWiseReport = () => {
  const [page, setPage] = React.useState(1);
  const [customersData, setCustomersData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [plantData, setPlantData] = useState<PlantsDropDown[]>([]);
  const [searchedColumn, setSearchedColumn] = useState('');
  const [unitId, setUnitId] = useState<number>(0);
  const [unitCodes,setUnitCodes]=useState([])
  const saleOrderService = new SaleOrderService();
  const { RangePicker } = DatePicker;
  const unitsService = new UnitcodeService()
  const searchInput = useRef(null);
  const { Text } = Typography;
  const { Option } = Select;
  const [form ] = useForm()
  useEffect(() => {
    getCustomersData();
    getAllPlants()
  }, []);

  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) { setTimeout(() => searchInput.current.select()); }
    },
    render: text =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : text
      ) : null
  });

  const getAllPlants = () => {
    unitsService.getAllManufacturingPlants().then((res) => {
        if (res.status) {
            setPlantData(res.data);
        } else {
            setPlantData([]);
        }
    }).catch(err => {
        AlertMessages.getErrorMessage(err.message);
        setPlantData([]);
    })
}

  function handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  function handleReset(clearFilters) {
    clearFilters();
  };

  const onFinish = () => {
    setPage(1); 
    getCustomersData();

  };

  const onReset = () => {
    form.resetFields()
    setPage(1); 
    setUnitId(null)
    getCustomersData();
    
  };

const getCustomersData = () => {
  const req = new DutyDrawBackReportReq();
  

  const invoiceDate = form.getFieldValue('invoiceDate');
  if (invoiceDate && invoiceDate[0] && invoiceDate[1]) {
    req.fromDate = invoiceDate[0].format('YYYY-MM-DD');
    req.toDate = invoiceDate[1].format('YYYY-MM-DD');
  } else {
    req.fromDate = undefined; 
    req.toDate = undefined; 
  }

  const selectedUnitId = form.getFieldValue('unitId');
  if (selectedUnitId && selectedUnitId !== 0) {
    req.unitId = selectedUnitId;
  } else {
    req.unitId = undefined; 
  }

  saleOrderService.getReceivablesAgingWiseData(req).then((res) => {
    if (res.status) {
      setCustomersData(res.data);
    } else {
      setCustomersData([]); 
      AlertMessages.getErrorMessage(res.internalMessage || 'Failed to fetch data');
    }
  }).catch((err) => {
    setCustomersData([]); 
    AlertMessages.getErrorMessage(err.message);
  });
};

  const formatINR = (amount: number) => {
    if (!amount) return '0';
    return `₹${new Intl.NumberFormat('en-IN').format(amount)}`;
  };

  const handleUnit = (value) => {
    setUnitId(value)
  }

  const exportExcel = () => {
    const exportedDataWithTotals = customersData.map((customer) => {
      const total =
        (parseFloat(customer.pendingAmount) || 0) +
        (parseFloat(customer.range30) || 0) +
        (parseFloat(customer.range30to60) || 0) +
        (parseFloat(customer.range60to90) || 0) +
        (parseFloat(customer.range90to150) || 0) +
        (parseFloat(customer.range150to180) || 0) +
        (parseFloat(customer.range180plus) || 0);
  
      return {
        ...customer,
        total, 
      };
    });

    const totals = {
      pendingAmount: 0,
      range30: 0,
      range30to60: 0,
      range60to90: 0,
      range90to150: 0,
      range150to180: 0,
      range180plus: 0,
      total: 0,
    };
  
    customersData.forEach((customer) => {
      totals.pendingAmount += parseFloat(customer.pendingAmount) || 0;
      totals.range30 += parseFloat(customer.range30) || 0;
      totals.range30to60 += parseFloat(customer.range30to60) || 0;
      totals.range60to90 += parseFloat(customer.range60to90) || 0;
      totals.range90to150 += parseFloat(customer.range90to150) || 0;
      totals.range150to180 += parseFloat(customer.range150to180) || 0;
      totals.range180plus += parseFloat(customer.range180plus) || 0;
      totals.total +=
        (parseFloat(customer.pendingAmount) || 0) +
        (parseFloat(customer.range30) || 0) +
        (parseFloat(customer.range30to60) || 0) +
        (parseFloat(customer.range60to90) || 0) +
        (parseFloat(customer.range90to150) || 0) +
        (parseFloat(customer.range150to180) || 0) +
        (parseFloat(customer.range180plus) || 0);
    });
  
    exportedDataWithTotals.push({
      endCustomerName: 'Total',
      pendingAmount: totals.pendingAmount,
      range30: totals.range30,
      range30to60: totals.range30to60,
      range60to90: totals.range60to90,
      range90to150: totals.range90to150,
      range150to180: totals.range150to180,
      range180plus: totals.range180plus,
      total: totals.total, 
    });

    const columns = [
      { title: 'S No', dataIndex: 'sNo', width: 70, render: (text, object, index) => index + 1 },
      {title:'Unit' ,dataIndex:'unitName', width:160,render:(text)=> text || '-'},
      {title:'Invoice Date' , dataIndex:'invoiceDate' ,width:110,render: (text) => text ? moment(text).format('DD-MM-YYYY') : '-'},
      { title: 'Customer Name', dataIndex: 'endCustomerName', width: 200, render: (text) => text || '-' },
      { title: 'Pending Bills', dataIndex: 'pendingAmount', width: 130, render: (text) => text || '-' },
      { title: 'Less than 30 days', dataIndex: 'range30', width: 130, render: (text) => text || '-' },
      { title: '30 to 60 days', dataIndex: 'range30to60', width: 130, render: (text) => text || '-' },
      { title: '60 to 90 days', dataIndex: 'range60to90', width: 130, render: (text) => text || '-' },
      { title: '90 to 150 days', dataIndex: 'range90to150', width: 130, render: (text) => text || '-' },
      { title: '150 to 180 days', dataIndex: 'range150to180', width: 130, render: (text) => text || '-' },
      { title: '180 days and Above', dataIndex: 'range180plus', width: 130, render: (text) => text || '-' },
    ];

    const excel = new Excel();
    excel
      .addSheet('Receivables Aging Report')
      .addColumns(columns) 
      .addDataSource(exportedDataWithTotals, { str2num: true })
      .saveAs('ReceivablesAgingReport.xlsx');
  };
  

  const getTotal = (pageData, key) => {
    return pageData.reduce((total, record) => total + (Number(record[key]) || 0), 0);
  };
  

  const columns = [
    {
      title: 'S No',
      key: 'sno',
      width: '70px',
      render: (text, record, index) => (page - 1) * 10 + (index + 1),
    },
    {title:'Unit' ,
      dataIndex:'unitName',
      width: '240px',
      sorter: (a, b) => a.unitName.localeCompare(b.unitName),
      sortDirections: ['descend', 'ascend'] as SortOrder[],
      ...getColumnSearchProps('unitName'),
       render:(text)=> text || '-',
    },
    {
      title:'Invoice Date' ,
       dataIndex:'invoiceDate' ,
       width: '120px',
       sorter: (a, b) => moment(a.invoiceDate).valueOf() - moment(b.invoiceDate).valueOf(),
       sortDirections: ['descend', 'ascend'] as SortOrder[],     
       render: (text) => text ? moment(text).format('DD-MM-YYYY') : '-'
      },
    {
      title: 'Customer Name',
      dataIndex: 'endCustomerName',
      key: 'endCustomerName',
      width: '240px',
      sorter: (a, b) => a.endCustomerName.localeCompare(b.endCustomerName),
      sortDirections: ['descend', 'ascend'] as SortOrder[],
      ...getColumnSearchProps('endCustomerName'),
      render: (value) => value || '-',
    },
    {
      title: 'Pending Bills',
      dataIndex: 'pendingAmount',
      key: 'pendingAmount',
      width: '140px',
      sorter: (a, b) => a.pendingAmount - b.pendingAmount,
      render: (value) => formatINR(value),
    },
    {
      title: 'Less than 30 days',
      dataIndex: 'range30',
      key: 'range30',
      width: '120px',
      render: (value) => formatINR(value),
    },
    {
      title: '30 to 60 days',
      dataIndex: 'range30to60',
      key: 'range30to60',
      width: '120px',
      render: (value) => formatINR(value),
    },
    {
      title: '60 to 90 days',
      dataIndex: 'range60to90',
      key: 'range60to90',
      width: '120px',
      render: (value) => formatINR(value),
    },
    {
      title: '90 to 150 days',
      dataIndex: 'range90to150',
      key: 'range90to150',
      width: '120px',
      render: (value) => formatINR(value),
    },
    {
      title: '150 to 180 days',
      dataIndex: 'range150to180',
      key: 'range150to180',
      width: '120px',
      render: (value) => formatINR(value),
    },
    {
      title: '180 days and Above',
      dataIndex: 'range180plus',
      key: 'range180plus',
      width: '120px',
      render: (value) => formatINR(value),
    },
  ];

  return (
    <div>
      <Card
        size="small"
        title={<span style={{ color: 'white' }}>EXPORT RECEIVABLES AGING WISE REPORT</span>}
        style={{ textAlign: 'center' }}
        headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
        extra={
          <div>
            <Button
              icon={<DownloadOutlined />}
              onClick={exportExcel}
              style={{ marginRight: 30 }}
            >
              Get Excel
            </Button>
          </div>
        }
      >
        
        <Form form={form} onFinish={onFinish}>
                <Row gutter={24}>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
                <Form.Item
                name="unitId"
                
                label="Unit"
                rules={[
                    {
                        required: false, message: 'Select Unit',
                    },
                ]}
            >
                <Select
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                    placeholder="Select Unit"
                    allowClear
                    style={{ width: '100%' }}
                    onChange={handleUnit}
                    // disabled={Number(localStorage.getItem('unit_id')) != 5 ? true : false}
                >
                    {plantData.map(dropData => {
                        return <Option value={dropData.plantId}>{dropData.plantName}</Option>
                    })}
                </Select>
            </Form.Item>
        </Col>

                  <Col>
                    <Form.Item label="Invoice Date" name="invoiceDate">
                      <RangePicker
                        />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{ background: "green", width: "100%" }}
                      >
                        Search
                      </Button>
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item>
                      <Button
                        danger
                        // icon={<UndoOutlined />}
                        onClick={onReset}
                        style={{ width: "100%" }}
                      >
                        Reset
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
        <Table
          style={{ padding: '5px ' }}
          size="small"
          columns={columns}
          dataSource={customersData}
          scroll={{ x: true }}
          bordered
          pagination={{
            // pageSize: 10,
            current: page,
            onChange: (currentPage) => setPage(currentPage),
          }}
          summary={(pageData) => {
            return (
              <Table.Summary.Row>
                <Table.Summary.Cell index={0}><Text></Text></Table.Summary.Cell>
                <Table.Summary.Cell index={1}><Text></Text></Table.Summary.Cell>
                <Table.Summary.Cell index={2}><Text></Text></Table.Summary.Cell>
                <Table.Summary.Cell index={3}><Text>Total</Text></Table.Summary.Cell>
                <Table.Summary.Cell index={4} align="right">
                  <Text>{formatINR(getTotal(pageData, 'pendingAmount')) || '0'}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5} align="right">
                  <Text>{formatINR(getTotal(pageData, 'range30')) || '0'}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6} align="right">
                  <Text>{formatINR(getTotal(pageData, 'range30to60')) || '0'}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={7} align="right">
                  <Text>{formatINR(getTotal(pageData, 'range60to90')) || '0'}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={8} align="right">
                  <Text>{formatINR(getTotal(pageData, 'range90to150')) || '0'}</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={9} align="right">
                  <Text>{formatINR(getTotal(pageData, 'range150to180')) || '0' }</Text>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={10} align="right">
                  <Text>{formatINR(getTotal(pageData, 'range180plus')) || '0'}</Text>
                </Table.Summary.Cell>
              </Table.Summary.Row>
            );
          }}
        />
      </Card>
    </div>
  );
};


export default ExportReceivablesAgingWiseReport;
